/* eslint-disable camelcase */
import { SodaGlobalParams } from '@/common/utils/request'
import { getBDCountry, getBDLocale } from '@/common/utils/i18n'
import daphne from '@didi/daphne-sdk-javascript'
import * as env from '@/common/utils/env'
import {checkVersion, isCanUpgradePopupShow} from '@/pages-v2/home/componnets/upgrade/utils'

// 获取首页list
export function setUpgrade ({ commit }, params) {
  commit('setUpgrade', params)
}

export async function checkUpgrade ({ commit }, params = {}) {
  const {callback, isCount = false} = params || {} // isCount本次检查弹窗是否记数，默认不计数
  const locale = getBDLocale()
  const country = getBDCountry()
  const { appVersion = '' } = await SodaGlobalParams()

  const result = await daphne.getToggle({
    ns: 'sailing_m_services_bdapp', // 命名空间
    name: env.isAndroid ? 'version_upgrade_config' : 'version_upgrade_config_ios', // 配置名称
    key: 'xiezuobing'
  })
  const { data = {} } = result || {}
  const { version_upgrade_config = {}, version_upgrade_config_ios = {} } = data
  const upgradeConfig = env.isAndroid ? version_upgrade_config : version_upgrade_config_ios
  const { params: upgradeData = {} } = upgradeConfig

  let content = {}
  let forceUpgrade = false

  try {
    content = JSON.parse(upgradeData.content)
    forceUpgrade = JSON.parse(upgradeData.forceUpgrade)
  } catch (e) {
    content = {}
    forceUpgrade = false
  }
  console.log('[log] country =>', country)

  upgradeData.content = content[locale || 'en-US']
  upgradeData.forceUpgrade = forceUpgrade[country || 'MX'] || false
  upgradeData.currentVersionName = appVersion
  const isUpgrade = checkVersion(appVersion, upgradeData.versionName)
  let canAutoUpgradePopupShow = isUpgrade
  if (isCount) {
    canAutoUpgradePopupShow = canAutoUpgradePopupShow && (upgradeData.forceUpgrade || isCanUpgradePopupShow(appVersion, upgradeData.versionName))
  }
  if (canAutoUpgradePopupShow) {
    commit('setUpgrade', isUpgrade)
  }
  commit('setIsUpgrade', isUpgrade)

  callback && callback(isUpgrade)

  commit('SetUpgradeData', upgradeData || {})
}
